type ReturnLocation = {
  pathname?: string
  search?: string
  hash?: string
}

type LoginState = {
  from?: string | ReturnLocation
  returnTo?: string
} | null

export const isSafeLocalPath = (value: unknown): value is string => (
  typeof value === 'string' && value.startsWith('/') && !value.startsWith('//')
)

const getStatePath = (state: LoginState): string | null => {
  if (!state) return null
  if (isSafeLocalPath(state.returnTo)) return state.returnTo
  if (isSafeLocalPath(state.from)) return state.from
  if (state.from && typeof state.from === 'object') {
    const path = `${state.from.pathname || ''}${state.from.search || ''}${state.from.hash || ''}`
    if (isSafeLocalPath(path)) return path
  }
  return null
}

export const getLoginReturnTo = ({
  search,
  state,
  storedReturnTo
}: {
  search: string
  state?: LoginState
  storedReturnTo?: string | null
}) => {
  const next = new URLSearchParams(search).get('next')
  if (isSafeLocalPath(next)) return next
  const statePath = getStatePath(state || null)
  if (statePath) return statePath
  if (isSafeLocalPath(storedReturnTo)) return storedReturnTo
  return '/'
}

export const getLoginPath = (returnTo: string) => (
  isSafeLocalPath(returnTo) && returnTo !== '/'
    ? `/login?next=${encodeURIComponent(returnTo)}`
    : '/login'
)
